import { all } from 'redux-saga/effects';

import { watchAddOns } from './addOns/saga';
import { watchAlerts } from './alerts';
import { watchAuth, watchUser } from './auth';
import { watchBillingInfo } from './billingInfo';
import { watchBroadbandLabelAttributes } from './broadbandLabel/broadbandLabelSagas';
import { watchBuyMore } from './buyMore';
import { watchBuyMoreHistory } from './buyMoreHistory';
import { watchChangePlanOffers } from './changePlan';
import { watchConfig } from './config';
import { watchCrossPlatformCommunication } from './crossPlatformCommunication';
import { watchUsernameMutations } from './deleteUsername';
import { watchDisconnect } from './disconnect';
import { watchEcaSaga } from './electronicCustomerAgreement';
import { watchEvents } from './events';
import { watchLocale } from './locale';
import { watchNetwork } from './network';
import { watchPayments } from './payments';
import { watchPlan } from './plan/planSagas';
import { watchPortfolio } from './portfolio/portfolioSagas';
import { watchPushNotification } from './pushNotifications';
import { watchRegistration } from './registration';
import { watchScheduleInstallation } from './scheduleInstallation/scheduleInstallationSagas';
import { watchScrubbedAddress } from './scrubbedAddress';
import { watchStreamOn } from './streamOn';
import { watchStreamOnPromo } from './streamOnPromo';
import { watchUpdateAddress } from './updateAddress';
import { watchUpdateBillCycle } from './updateBillCycle/sagas';
import { watchHistoricalUsageInfo } from './usageHistory';
import { watchUserInfo } from './userInfo';
import { watchWorkOrders } from './workOrders/workOrdersSagas';

import { watchUtils } from './utils';

function* rootSaga() {
  yield all([
    watchUtils(),
    watchCrossPlatformCommunication(),
    watchConfig(),
    watchUpdateAddress(),
    watchEvents(),
    watchStreamOn(),
    watchAuth(),
    watchUser(),
    watchUsernameMutations(),
    watchLocale(),
    watchScrubbedAddress(),
    watchRegistration(),
    watchUserInfo(),
    watchBuyMoreHistory(),
    watchHistoricalUsageInfo(),
    watchStreamOnPromo(),
    watchBillingInfo(),
    watchPayments(),
    watchBuyMore(),
    watchAlerts(),
    watchChangePlanOffers(),
    watchPushNotification(),
    watchScheduleInstallation(),
    watchUpdateBillCycle(),
    watchPortfolio(),
    watchNetwork(),
    watchPlan(),
    watchBroadbandLabelAttributes(),
    watchWorkOrders(),
    watchEcaSaga(),
    watchAddOns(),
    watchDisconnect(),
  ]);
}

export default rootSaga;
